var _filter, _filter2, _rect, _polygon, _polygon2, _path, _line, _line2, _line3, _line4, _line5, _line6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _clipPath, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoraraAnimated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 220 220",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10B981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#14B8A6"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glow2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "#0A1114",
    rx: 20
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "110,12 198,60 198,160 110,208 22,160 22,60",
    fill: "none",
    stroke: "url(#grad1)",
    strokeWidth: 1.5,
    opacity: 0.4,
    strokeDasharray: 480,
    strokeDashoffset: 480
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 480,
    to: 0,
    dur: "2s",
    fill: "freeze",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;0.7;0.4",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "2s"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "110,30 182,72 182,148 110,190 38,148 38,72",
    fill: "rgba(10,17,20,0.9)",
    stroke: "url(#grad1)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 0.5,
    dur: "0.5s",
    fill: "freeze",
    begin: "1.5s"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 52 L105 52 Q155 52 155 110 Q155 168 105 168 L68 168 Z",
    fill: "rgba(16,185,129,0.06)",
    stroke: "url(#grad1)",
    strokeWidth: 2.5,
    filter: "url(#glow)",
    strokeDasharray: 320,
    strokeDashoffset: 320
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 320,
    to: 0,
    dur: "1.5s",
    fill: "freeze",
    begin: "0.5s"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 52,
    x2: 68,
    y2: 168,
    stroke: "url(#grad1)",
    strokeWidth: 3.5,
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.3s",
    fill: "freeze",
    begin: "2s"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 80,
    x2: 140,
    y2: 80,
    stroke: "#10B981",
    strokeWidth: 0.8,
    opacity: 0,
    strokeDasharray: 80,
    strokeDashoffset: 80
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 80,
    to: 0,
    dur: "0.6s",
    fill: "freeze",
    begin: "2.2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 0.35,
    dur: "0.3s",
    fill: "freeze",
    begin: "2.2s"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 95,
    x2: 148,
    y2: 95,
    stroke: "#10B981",
    strokeWidth: 0.8,
    opacity: 0,
    strokeDasharray: 88,
    strokeDashoffset: 88
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 88,
    to: 0,
    dur: "0.6s",
    fill: "freeze",
    begin: "2.4s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 0.35,
    dur: "0.3s",
    fill: "freeze",
    begin: "2.4s"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 110,
    x2: 155,
    y2: 110,
    stroke: "#10B981",
    strokeWidth: 1.5,
    opacity: 0,
    strokeDasharray: 90,
    strokeDashoffset: 90
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 90,
    to: 0,
    dur: "0.6s",
    fill: "freeze",
    begin: "2.6s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 0.6,
    dur: "0.3s",
    fill: "freeze",
    begin: "2.6s"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 125,
    x2: 148,
    y2: 125,
    stroke: "#10B981",
    strokeWidth: 0.8,
    opacity: 0,
    strokeDasharray: 88,
    strokeDashoffset: 88
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 88,
    to: 0,
    dur: "0.6s",
    fill: "freeze",
    begin: "2.8s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 0.35,
    dur: "0.3s",
    fill: "freeze",
    begin: "2.8s"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 140,
    x2: 140,
    y2: 140,
    stroke: "#10B981",
    strokeWidth: 0.8,
    opacity: 0,
    strokeDasharray: 80,
    strokeDashoffset: 80
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 80,
    to: 0,
    dur: "0.6s",
    fill: "freeze",
    begin: "3.0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 0.35,
    dur: "0.3s",
    fill: "freeze",
    begin: "3.0s"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80,
    r: 2.5,
    fill: "#10B981",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.3s",
    fill: "freeze",
    begin: "2.8s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "3.5s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 95,
    r: 2.5,
    fill: "#14B8A6",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.3s",
    fill: "freeze",
    begin: "2.9s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "3.7s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 110,
    r: 3.5,
    fill: "#10B981",
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.3s",
    fill: "freeze",
    begin: "3.0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "3.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5;4.5;3.5",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "3.5s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 2.5,
    fill: "#14B8A6",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.3s",
    fill: "freeze",
    begin: "3.1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "3.9s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 140,
    r: 2.5,
    fill: "#10B981",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.3s",
    fill: "freeze",
    begin: "3.2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "4.1s"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 52,
    r: 4.5,
    fill: "#10B981",
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.4s",
    fill: "freeze",
    begin: "2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "2.5s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 110,
    r: 4,
    fill: "#14B8A6",
    filter: "url(#glow2)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.4s",
    fill: "freeze",
    begin: "2.2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4;5.5;4",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "3s"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 168,
    r: 4.5,
    fill: "#10B981",
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.4s",
    fill: "freeze",
    begin: "2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "3s"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 12,
    r: 3.5,
    fill: "#10B981",
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    fill: "freeze",
    begin: "2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "2.5s"
  }))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 60,
    r: 3.5,
    fill: "#10B981",
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    fill: "freeze",
    begin: "2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "2.9s"
  }))), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 160,
    r: 3.5,
    fill: "#14B8A6",
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    fill: "freeze",
    begin: "2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "3.3s"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 208,
    r: 3.5,
    fill: "#14B8A6",
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    fill: "freeze",
    begin: "2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "3.7s"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 160,
    r: 3.5,
    fill: "#10B981",
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    fill: "freeze",
    begin: "2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "4.1s"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 60,
    r: 3.5,
    fill: "#10B981",
    filter: "url(#glow)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    fill: "freeze",
    begin: "2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "4.5s"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "dClip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 48 L108 48 Q160 48 160 110 Q160 172 108 172 L62 172 Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 140,
    height: 2,
    fill: "url(#grad1)",
    opacity: 0.7,
    clipPath: "url(#dClip)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0,52; 0,168; 0,52",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "4s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.7;0.7;0",
    keyTimes: "0;0.1;0.9;1",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "4s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoraraAnimated);
export default __webpack_public_path__ + "static/media/dorara-animated.54e8b13feedcce8d80805034b1616186.svg";
export { ForwardRef as ReactComponent };